<section class="section-div">
  <div class="header-div d-flex">
    <h4><i class="fas fa-file-signature mr-2"></i>Declaration</h4>
    <div class="header-div ml-auto">
      <h6>
        Your Application Number :
        <span class="application-color">{{
          applicationNo || "Not Generated"
          }}</span>
      </h6>
    </div>
  </div>

  <div class="content-details">
    <form action="" [formGroup]="declaration">
      <div class="row">
        <div class="col-lg-4 col-md-4 col-md-12 col-12">
          <div class="form-rows mt-3" *ngIf="!showForm">
            <mat-label>Annexure <span class="text-danger"> *</span></mat-label>
            <label *ngIf="disName != '✔ Uploaded'" for="input-file-id" class="md-button md-raised md-primary">
              Choose File
              <ion-icon class="ml-3" name="cloud-upload-outline"></ion-icon>
              <span class="ml-3">{{ disName }}</span>
              <input class="d-none" id="input-file-id" type="file" (change)="fileUpload($event)" />
            </label>
            <label *ngIf="disName == '✔ Uploaded'" for="input-file-id" class="md-button md-raised md-accent">
              Update File
              <ion-icon class="ml-3" name="cloud-upload-outline"></ion-icon>
              <span class="ml-3">{{ disName }}</span>
              <input class="d-none" id="input-file-id" type="file"
                (change)="fileUpload($event, annexureDoc, annexureDocName)" />
            </label>
            <span class="noti-span">
              (Supported Format: pdf) (max file size: 5mb)
            </span>
            <p *ngIf="fileErrorShow == true" class="text-danger">
              File size exceeds the limit ({{ maxSizeMB }}MB)
            </p>
            <div class="mt-2 mb-3" *ngIf="disNames == '✔ Uploaded' && getValue">
              <a class="pdf-btn" href="{{ FileName }}" target="_blank">Download & View Document</a>
            </div>
            <mat-error *ngIf="fileError == true">
              <span class="d-block">Annexure is required</span>
            </mat-error>
          </div>

          <div class="form-rows mt-3" *ngIf="showForm" disabled>
            <mat-label>Annexure <span class="text-danger"> *</span></mat-label>
            <label *ngIf="disName != '✔ Uploaded'" for="input-file-id" class="md-button md-raised md-primary">
              Choose File
              <ion-icon class="ml-3" name="cloud-upload-outline"></ion-icon>
              <span class="ml-3">{{ disName }}</span>
              <input class="d-none" id="input-file-id" readonly />
            </label>
            <label *ngIf="disName == '✔ Uploaded'" for="input-file-id" class="md-button md-raised md-accent"
              style="cursor: not-allowed">
              Update File
              <ion-icon class="ml-3" name="cloud-upload-outline"></ion-icon>
              <span class="ml-3">{{ disName }}</span>
              <input class="d-none" id="input-file-id" readonly />
            </label>
            <span class="noti-span">
              (Supported Format: pdf) (max file size: 5mb)
            </span>
            <p *ngIf="
                logoCheck &&
                selecetdFile &&
                selecetdFile.size / (1024 * 1024) > maxSizeMB
              " class="text-danger">
              File size exceeds the limit ({{ maxSizeMB }}MB)
            </p>
            <div class="mt-2 mb-3" *ngIf="disNames == '✔ Uploaded' && getValue">
              <a class="pdf-btn" href="{{ FileName }}" target="_blank">Download & View Document</a>
            </div>
            <mat-error *ngIf="fileError == true">
              <span class="d-block">Annexure is required</span>
            </mat-error>
          </div>
          <div class="documents">
            <p>
              Download
              <Span (click)="downloadFile()" style="cursor: pointer">Annexure Template</Span>
            </p>
          </div>
        </div>
        <div class="col-lg-4 col-md-4 col-md-12 col-12"></div>
        <div class="col-lg-4 col-md-4 col-md-12 col-12">
          <div class="activity-container">
            <h6>No. of Questions Filled</h6>
            <div class="box-progress-wrapper">
              <p class="box-progress-header">
                Questions
                <span>({{ getValues.questionsfilled }}/{{
                  getValues.totalquestions
                  }})</span>
              </p>
              <div class="box-progress-bar">
                <span class="box-progress" [style.width.%]="
                    (getValues.notImplemented / getValues.totalquestions) * 100
                  " style="background-color: #56c2e6"></span>
              </div>
              <p class="box-progress-percentage">
                {{
                (getValues.questionsfilled / getValues.totalquestions) * 100
                | number : "1.0-0"
                }}
                %
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="declaration-show-light" *ngIf="showDeclarations == false">
        <div class="form-rows mt-3">
          <mat-checkbox class="example-margin" formControlName="terms1" disabled
            (change)="declaration1($event.checked)">
            I hereby confirm that<span class="text-danger">
              *</span></mat-checkbox>
          <ul class="additional-info">
            <li>
              I have filled in all the required fields in the form. All
              necessary documents have been attached wherever required
            </li>
          </ul>
        </div>
        <div class="form-rows mt-3">
          <mat-checkbox class="example-margin" formControlName="terms2" disabled
            (change)="declaration2($event.checked)">
            I hereby confirm that<span class="text-danger">
              *</span></mat-checkbox>
          <ul class="additional-info">
            <li>
              All the above information has been verified and I provide my
              consent to Startup TN to proceed with further action accordingly
            </li>
          </ul>
        </div>
        <div class="text-center mt-3">
          <button mat-raised-button color="primary" (click)="finalSave()" *ngIf="coeStatus != 3" disabled>
            Submit
          </button>
          <button mat-raised-button color="primary" (click)="finalSave()" *ngIf="coeStatus == 3" disabled>
            Re-Submit
          </button>
        </div>
      </div>
      <div class="declaration-show-light" *ngIf="showDeclarations == true && isRegistrationClosedCOE == true">
        <div class="form-rows mt-3">
          <mat-checkbox class="example-margin" formControlName="terms1" disabled
            (change)="declaration1($event.checked)">
            I hereby confirm that<span class="text-danger">
              *</span></mat-checkbox>
          <ul class="additional-info">
            <li>
              I have filled in all the required fields in the form. All
              necessary documents have been attached wherever required
            </li>
          </ul>
        </div>
        <div class="form-rows mt-3">
          <mat-checkbox class="example-margin" formControlName="terms2" disabled
            (change)="declaration2($event.checked)">
            I hereby confirm that<span class="text-danger">
              *</span></mat-checkbox>
          <ul class="additional-info">
            <li>
              All the above information has been verified and I provide my
              consent to Startup TN to proceed with further action accordingly
            </li>
          </ul>
        </div>
        <div class="text-center mt-3">
          <button mat-raised-button color="primary" (click)="finalSave()" *ngIf="coeStatus != 3" disabled>
            Submit
          </button>
          <button mat-raised-button color="primary" (click)="finalSave()" *ngIf="coeStatus == 3" disabled>
            Re-Submit
          </button>
        </div>
      </div>
      <div class="declaration-show-dark" *ngIf="showDeclarations == true && isRegistrationClosedCOE == false">
        <div class="form-rows mt-3">
          <mat-checkbox class="example-margin" formControlName="terms1" [disabled]="showDeclaration"
            (change)="declaration1($event.checked)">
            I hereby confirm that<span class="text-danger">
              *</span></mat-checkbox>
          <ul class="additional-info">
            <li>
              I have filled in all the required fields in the form. All
              necessary documents have been attached wherever required
            </li>
          </ul>
          <mat-error *ngIf="setting.terms1.touched && setting.terms1.errors">
            <span class="d-block" *ngIf="setting.terms1.errors.required">required</span>
          </mat-error>
        </div>
        <div class="form-rows mt-3">
          <mat-checkbox class="example-margin" formControlName="terms2" [disabled]="showDeclaration"
            (change)="declaration2($event.checked)">
            I hereby confirm that<span class="text-danger">
              *</span></mat-checkbox>
          <ul class="additional-info">
            <li>
              All the above information has been verified and I provide my
              consent to Startup TN to proceed with further action accordingly
            </li>
          </ul>
          <mat-error *ngIf="setting.terms2.touched && setting.terms2.errors">
            <span class="d-block" *ngIf="setting.terms2.errors.required">required</span>
          </mat-error>
        </div>
        <div class="text-center mt-3">
          <button mat-raised-button color="primary" *ngIf="coeStatus != 3" (click)="finalSave()">
            Submit
          </button>
          <button mat-raised-button color="primary" *ngIf="coeStatus == 3" (click)="reSubmit()">
            Re-Submit
          </button>
        </div>
      </div>
    </form>
  </div>
</section>
<!-- modal -->
<div id="editModal" class="modal">
  <div class="modal-content text-center">
    <div class="text-center">
      <img class="image-sec" style="width: 100px" src="/assets/images/attention -man.gif" alt="" />
    </div>
    <h3 style="font-size: 22px; font-weight: 500">Are You Sure</h3>

    <div class="text-center mt-2">
      <button class="incubatorBtn" (click)="closeModal()">Review</button>
      <button class="successBtn ml-2" (click)="saveModal()">Submit</button>
    </div>
  </div>
</div>
<!-- modal -->
<div id="reSubmitModal" class="modal">
  <div class="modal-content text-center">
    <div class="text-center">
      <img class="image-sec" style="width: 100px" src="/assets/images/attention -man.gif" alt="" />
    </div>
    <h3 style="font-size: 22px; font-weight: 500">Are You Sure</h3>

    <div class="text-center mt-2">
      <button class="incubatorBtn" (click)="closeModal()">Review</button>
      <button class="successBtn ml-2" (click)="reSubmitModal()">
        Re-Submit
      </button>
    </div>
  </div>
</div>